import { ID } from './id';

export enum InsightsTimeframes {
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
  FourWeeks = 'four-weeks',
  TwelveWeeks = 'twelve-weeks',
  TwelveMonths = 'twelve-months',
}

export enum InsightSections {
  Goals = 'goals',
  Habits = 'habits',
  Lifescan = 'lifescan',
}

export const insightsTimeframes = Object.values(InsightsTimeframes);

// The timeframes that support period navigation (prev/next). Excludes the
// fixed-window variants (4w/12w/12m), which have no concept of a previous or
// next period.
export const navigableInsightsTimeframes = [
  InsightsTimeframes.Week,
  InsightsTimeframes.Month,
  InsightsTimeframes.Quarter,
  InsightsTimeframes.Year,
];

export const fallbackTimeframe = InsightsTimeframes.Month;

export type SectionInsights = {
  hiddenItems: ID[];
  extraItems: ID[];
  order: ID[];
};

export type Insights = {
  timeframe?: InsightsTimeframes;
  showHiddenItems?: boolean;
  showActiveSubGoals?: boolean;
  sections?: Partial<Record<InsightSections, SectionInsights | null>> | null;
};
